export { default } from "../.internal/themes/kelly";
